"use client";

import cn from "classnames";
import { useEffect } from "react";
import { useSearchParams } from "next/navigation";

import type { ReactNode } from "react";
import type { Article } from "../../../../types/content";

import styles from "./SalesPosterContainer.module.scss";
import { usePulse } from "../../../../pulse/usePulse";
import { getHref } from "./helper";

const PulseTrackSalesPosterImpression = ({
  children,
  article,
  isOmniEconomy,
}: {
  children: ReactNode;
  article?: Article;
  isOmniEconomy: boolean;
}) => {
  const { trackSalesPosterImpression } = usePulse();

  const searchParams = useSearchParams();

  useEffect(() => {
    if (article) {
      const href = getHref(isOmniEconomy, article);
      trackSalesPosterImpression(href, article, searchParams);
    }
  }, [isOmniEconomy, article, trackSalesPosterImpression, searchParams]);

  return <div className={cn([styles.salesPoster, "paywall"])}>{children}</div>;
};

export { PulseTrackSalesPosterImpression };
